import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import { stringFormat, generateMediaFilename } from '../utils/formatting';
import { parseJSON, isOk } from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function setWatchFilters(filters) {
  return {
    type: constants.WATCHES_FILTER_SAVE,
    filters
  };
}

export function watchesSave(watches, count = 0) {
	return {
    type: constants.WATCHES_SAVE,
    watches,
    count,
  };
}

export function watchesSaveSelected(watches) {
	return {
    type: constants.WATCHES_SAVE_SELECTED,
    watches,
  };
}

export function watchesSetLastPosition(scrollPos) {
	return {
    type: constants.WATCHES_SET_LAST_POSITION,
    scrollPos,
  };
}

export function watchesToggleListView() {
	return {
    type: constants.WATCHES_TOGGLE_LIST,
  };
}



/******************************
*******  Asynchronous  ********
******************************/




export function fetchWatches(watchFilters, page) {

	return dispatch => {

		let first = true;
		let getParams = '';

		const pageInt = parseInt(page);
		const PAGE_SIZE = 100;
		const pagination = {
			limit: PAGE_SIZE,
			offset: PAGE_SIZE*(pageInt - 1),
		}

		let pageFilters = Object.assign({}, watchFilters, pagination);

		let filterKeys = Object.keys(pageFilters);
		for(let i = 0; i < filterKeys.length; i++) {

			if(first) {
				getParams = '?' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			} else {
				getParams += '&' + filterKeys[i] + '=' + pageFilters[filterKeys[i]];
			}
			first = false;
		}
		let encodedParams = encodeURI(getParams);

		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_WATCH_FETCH_LIST + encodedParams;
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data.success);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchSingleWatch(sku) {

	return dispatch => {
		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_WATCH_FETCH_BY_SKU + '?sku=' + sku;
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


// No refresh method; should always be called via other action
export function watchGetMediaPostCode(sku, filename, signal = null) {
	return async (dispatch, getState) => {

		const url = api.PRODUCT_API_URL + stringFormat(endpoint.PRODUCT_WATCH_FETCH_GENERATE_POST, { 
			sku: sku,
			filename: encodeURIComponent(filename), 
		});

		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		  signal,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function watchUploadMedia(sku, file, signal = null) {
	return async (dispatch, getState) => {

		const codeDispatch = await watchGetMediaPostCode(sku, generateMediaFilename(file), signal);
		const codeResp = await codeDispatch();
		if(!codeResp) {
			return Promise.reject();
		}

		// Forward every field the presigned POST came back with instead of naming them.
		// The set varies with how the API's boto3 client was credentialed: task-role
		// credentials add x-amz-security-token, and a SigV4 region swaps AWSAccessKeyId /
		// signature for the x-amz-* family. Any field the signed policy requires and we
		// leave out is a 403 from S3.
		const formData = new FormData();
		formData.append('Content-Type', file.type || 'application/octet-stream');
		for(const [field, value] of Object.entries(codeResp.fields)) {
			formData.append(field, value);
		}
		// Must stay last: S3 ignores any form field that follows `file`.
		formData.append('file', file);

		return fetch(codeResp.url, {
		  method: 'post',
		  body: formData,
		  signal,
		})
		// .then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve({
	    		key: codeResp.fields.key,
	    	});
	    } else {
	    	return Promise.reject({ msg: `Upload to storage failed (${resp.status})` });
	    }
	  });
	}
}


export function watchUpdateMedia(imageData) {
	return dispatch => {
		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_WATCH_FETCH_UPDATE_IMAGE;
		return fetch(url, {
		  method: 'post',
		  body: JSON.stringify(imageData),
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function watchDeleteMedia(deleteData) {
	return dispatch => {
		let url = api.PRODUCT_API_URL + endpoint.PRODUCT_WATCH_FETCH_DELETE_IMAGE;
		return fetch(url, {
		  method: 'delete',
		  body: JSON.stringify(deleteData),
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}






